import {Component, Inject, OnInit} from 'ng-metadata/core';
import {beacon, PrimolyticsService} from "../../analytics/primolytics.service";
import {LoginService} from "../login/login.service";
import {MediaQueries} from "../../infra/mediaQueries.service";
import {SearchService} from "../../search/search.service";
import {SharedSessionStorage} from "../../infra/sharedSessionStorage.service";
import {PrimoExploreService} from "../../primoExplore/primoExplore.service";
import {TimeoutToastService} from "./timeoutToast.service";
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";

@Component({
    selector: 'prm-timeout-toast',
    templateUrl: 'components/security/timeoutToast/timeout-toast.html',
})

export class PrmTimeoutToast implements OnInit{
    private _currentState: string;
    constructor(private primolyticsService: PrimolyticsService,
                @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$location') private $location: ng.ILocationService,
                private loginService: LoginService,
                private mediaQueries: MediaQueries,
                private searchService: SearchService,
                private sharedSessionStorage: SharedSessionStorage,
                private primoExploreService: PrimoExploreService,
                private timeoutToastService: TimeoutToastService,
                private configurationUtil: ConfigurationUtil) {
    }

    ngOnInit() {
        this.currentState = this.$location.path();
    }

    private onDismiss() {
        this.$mdToast.hide();

    }

    public detectMobile(){
        if( this.mediaQueries.xs || this.mediaQueries.sm){
            return true;
        }
        return false;
    }

    @beacon({'p':'general', 'op':'signIn'})
    handleLogin() {
        this.$mdToast.hide();
        this.$timeout(()=>{
            this.loginService.handleLoginClick();
        }, 200);
    }

    public isSearchDone() {
        return this.searchService.isSearchDone();
    }

    public isLogOutFromPopupMessage() {
        return this.primoExploreService.showTimeOutMessage;
    }

    public showToastMessage() {
        return !this.isStateChange() && this.timeoutToastService.showTimeOutToastMessage;
    }

    get currentState() {
        return this._currentState;
    }

    set currentState(value) {
        this._currentState = value;
    }

    private isStateChange(){
        if (this.currentState !== this.$location.path()){
            return true;
        }
        return false;
    }

    public isKeepMeSignInFeatureFlag() {
        let keepMeSignInFeatureFlag = this.configurationUtil.getFeatureFlag('enable_patrons_to_check_keep_me_signed_in');
        return this.configurationUtil.getBackendSystem() === 'suprima' && keepMeSignInFeatureFlag;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/timeoutToast/timeoutToast.directive.ts